export class NotArrayError extends Error {
    constructor() {
        super('Element is not an Array');
    }
}